// PRO Drift Auditor -- shared section card wrapper for consistent chrome.

import React from 'react';

interface CardProps {
    title: string;
    subtitle?: string;
    icon?: React.ReactNode;
    right?: React.ReactNode;
    className?: string;
    bodyClassName?: string;
    children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
    title,
    subtitle,
    icon,
    right,
    className = '',
    bodyClassName = '',
    children,
}) => (
    <section
        className={`bg-white dark:bg-slate-900/70 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden ${className}`}
    >
        <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3">
            <div className="flex items-start gap-2.5">
                {icon && (
                    <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-indigo-50 dark:bg-indigo-500/15 text-indigo-600 dark:text-indigo-300">
                        {icon}
                    </span>
                )}
                <div>
                    <h3 className="text-base font-bold text-slate-800 dark:text-white leading-tight">
                        {title}
                    </h3>
                    {subtitle && (
                        <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{subtitle}</p>
                    )}
                </div>
            </div>
            {right}
        </div>
        <div className={bodyClassName || 'px-5 pb-5'}>{children}</div>
    </section>
);
